import { Model, OptionModel } from "services/models/model";
import { IModel } from "./../IModel";
import { ObjectMapper } from "json-object-mapper";

export class AbsenceTypeModel
  extends Model
  implements IModel<AbsenceTypeModel> {
  code: string = "";
  description: string = "";

  static create(input: any): AbsenceTypeModel {
    return ObjectMapper.deserialize<AbsenceTypeModel>(
      AbsenceTypeModel,
      input
    );
  }

  toOption(): OptionModel {
    return {
      label: `${this["code"]} - ${this["description"]}`,
      value: this.id,
    } as OptionModel;
  }
}
